import { createAction } from '@reduxjs/toolkit';

export const performanceActions = {
  loadTableConfigPerformance: {
    setRequestTimestamp: createAction<number>('loadTableConfigPerformance/setRequestTimestamp'),
    setResponseTimestamp: createAction<number>('loadTableConfigPerformance/setResponseTimestamp'),
  },
  enginePerformance: {
    setRequestTimestamp: createAction<number>('enginePerformance/setRequestTimestamp'),
    setResponseTimestamp: createAction<number>('enginePerformance/setResponseTimestamp'),
  },
  getChatUserPerformance: {
    setRequestTimestamp: createAction<number>('getChatUserPerformance/setRequestTimestamp'),
    setResponseTimestamp: createAction<number>('getChatUserPerformance/setResponseTimestamp'),
  },
  videoPerformance: {
    setRequestTimestamp: createAction<number>('videoPerformance/setRequestTimestamp'),
    setResponseTimestamp: createAction<number>('videoPerformance/setResponseTimestamp'),
  },
  setGameLoaded: createAction<number>('performance/setGameLoaded'),
};
